"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mod = function (value, by) { return ((value % by) + by) % by; };
exports.clamp = function (value, min, max) { return Math.max(Math.min(value, max), min); };
